import type { Brand } from '../brand.types.ts';

import logoWhite from './assets/logo-white.svg';
import meta from './meta.json';

// meta.json is shared with the build-time theme plugin, which stamps these
// values into index.html; importing the same file here keeps the runtime
// Brand object and the static HTML from drifting apart.
export const BRAND: Brand = {
  name: 'Leadtone',
  appTitle: meta.appTitle,
  cardLogoUrl: logoWhite,
  cardLogoAlt: 'Leadtone',
  chromeColor: meta.chromeColor,
  fontsHref: meta.fontsHref,
  supportAgent: true,
};
